import { DummyStore } from 'stores';

import { SystemUsersResponse } from '../types/systemUsers-response.type';

export namespace SystemUsersStore {
  export const systemUsers = new DummyStore<SystemUsersResponse>();
}
